export default __webpack_public_path__ + "f0832d0bdec9291e910f1bc9c8ae9e78.jpg";